// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"a7607add","642":"74c1a1d5"}[chunkId] + ".chunk.js";
};